import * as Actions from '../../../Modules/CmsActions'
import type { Workspace } from '../../../Types'

interface IWorkspaceState {
  info: Workspace | null
}

const initialState: IWorkspaceState = {
  info: null,
}

const WorkspaceReducer = (
  state: IWorkspaceState = initialState,
  action,
): IWorkspaceState => {
  const { payload } = action

  switch (action.type) {
    case Actions.LOADED_INITIAL_VALUES:
      return payload.workspace

    case Actions.LOGOUT:
      return initialState

    default:
      return state
  }
}

export default WorkspaceReducer
